<template>
  <div>
    <!-- 头部 -->
    <div class="head-border">
      <div class="header">
        <img src="@/assets/img/shopvidi_logo.png" class="logo_img" @click="gotoShopvidi"/>
        <el-divider direction="vertical"></el-divider>
        <div class="header-content">Wholesale Partner Program</div>
      </div>
      <div class="header-action" v-if="!login">
        <div class="action black" @click="gotoLogin">Login</div>
        <div class="action" @click="gotoRegister">Sign Up</div>
      </div>
    </div>
    <!-- <header
      :isShowAction="isShowAction"
      @gotoLogin="gotoLogin"
      @gotoRegister="gotoRegister"
    /> -->
    <!-- 主要部分 -->
    <div class="home_main">
      <!-- 第一板块 -->
      <div class="home_main1">
        <div class="home_main1_content">
          <div class="home_main1_content_left">
            <div class="home_main1_content_text">Together we grow Expanding your business</div>
            <div class="home_main1_content_action" @click="gotoRegister">Join Now</div>
          </div>
          <div class="home_main1_content_right">
            <img src="@/assets/img/home/wpp1_2.png"/>
          </div>
        </div>
        <div class="home_main1_content_mobile">
            <img src="@/assets/img/home/wpp1_2.png"/>
          </div>
      </div>
      <!-- 第二板块 -->
      <div class="home_main_2">
        <div class="home_main_2_title">Proven high sell-through brands</div>
        <div class="home_main_2_sub_title">Give wholesale partners access to proven high sell-through feature brands with competitive wholesale prices</div>
        <div class="brands-swiper">
          <awesome-swiper :pagination="true" :turnPages="turnPages" :swiperData="store" :prevName="'topbrands'" :nextName="'topbrands'">
            <swiper-slide v-for="(e,i) in brandList" :key="i">
              <div class="brands-swiper-list" @click="open(e.seoUrl)">
                <div class="brands-swiper-img"><img :src=e.brandLogoUrl alt=""></div>
              </div>
            </swiper-slide>
          </awesome-swiper>
        </div>
      </div>
      <!-- 第三板块 -->
      <div class="home_main_border">
        <div class="home_main_3">
          <div class="home_main_3_title">Our advantage</div>
          <div class="home_main_3_row">
            <div class="home_main_3_row_sub">
              <div class="home_main_3_row_sub_img"><img src="@/assets/img/home/wpp3_1.png"/></div>
              <div class="home_main_3_row_sub_title">Proven high sell-through brands</div>
              <div class="home_main_3_row_sub_text">Access to worldwide trusted independent brands, with significantly high gross profit margin, and you can try our selected sample kit before bulk purchasing</div>
            </div>
            <div class="home_main_3_row_sub">
              <div class="home_main_3_row_sub_img"><img src="@/assets/img/home/wpp3_2.png"/></div>
              <div class="home_main_3_row_sub_title">Free CRM tools</div>
              <div class="home_main_3_row_sub_text">Manage sales, receive and track order, stay connected with customers, and perform activities analysis</div>
            </div>
          </div>
          <div class="home_main_3_row">
            <div class="home_main_3_row_sub">
              <div class="home_main_3_row_sub_img"><img src="@/assets/img/home/wpp3_3.png"/></div>
              <div class="home_main_3_row_sub_title">Dedicated Cilent Manager</div>
              <div class="home_main_3_row_sub_text">Support from local Client Experience Manager, to listen to you closely and satisfy your needs with our ShopVidi platform.</div>
            </div>
            <div class="home_main_3_row_sub">
              <div class="home_main_3_row_sub_img"><img src="@/assets/img/home/wpp3_4.png"/></div>
              <div class="home_main_3_row_sub_title">ViDirect Plan</div>
              <div class="home_main_3_row_sub_text">Help you reaching more customers and boosting the revenue via ShopVidi’s nationwide sales leads</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 第四板块 -->
      <div class="home_main_4">
        <div class="home_main_4_title">How to join us</div>
        <div class="home_main_4_img"><img src="@/assets/img/home/wpp4_1.png"/></div>
        <div class="home_main_4_action" @click="gotoRegister">Join Now</div>
      </div>
      <!-- 分割线 -->
      <!-- <el-divider></el-divider> -->
      <!-- 底部 -->
      <!-- <div class="bottom">© 2022 ShopVidi, All Rights Reserved</div> -->
      <home-footer/>
    </div>
    <register-dialog
      :loginVisible="loginVisible"
      :type="type"
      @backVisible="backVisible"
      @changeForm="changeForm"
    />
  </div>
</template>

<script>
import {getAction} from '@/api/manage.js'
import awesomeSwiper from './components/awesomeSwiper.vue'
import {swiperSlide} from 'vue-awesome-swiper'
import RegisterDialog from './register/register-dialog.vue'
import Header from './components/header.vue'
import HomeFooter from './components/home-footer'
export default {
  components: {
    awesomeSwiper,
    swiperSlide,
    RegisterDialog,
    Header,
    HomeFooter
  },
  data() {
    return {
      brandList: [],
      store: {
        slidesPerGroup: 1,
        slidesPerColumn: 1,
        slidesPerView: 8,
        spaceBetween: 20,
        loopFillGroupWithBlank: true,
        loop: true,
        autoplay: {
          delay: 1500,
          disableOnInteraction: false
        }
      },
      turnPages: true,
      loginVisible: false,
      type: 'register',
      isShowAction: true
    }
  },
  computed: {
    isMobile() {
      const isMob = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return isMob
    }
  },
  created() {
    this.handleRouter()
    // 获取上架品牌信息
    this.loadBrands()
    if (this.isMobile) {
      this.store = {
        slidesPerGroup: 1,
        slidesPerColumn: 2,
        slidesPerView: 2,
        spaceBetween: 10,
        loopFillGroupWithBlank: true,
        loop: true,
        autoplay: {
          delay: 1500,
          disableOnInteraction: false
        }
      }
      this.turnPages = false
    }
  },
  methods: {
    handleRouter() {
      if (this.login) {
        // 获取用户信息
        let userInfo = JSON.parse(localStorage.getItem('pro__userInfo')).value
        if (userInfo) {
          getAction('/brand/api/v0.2/businesses/' + userInfo.id).then(response => {
            if (response.success) {
              if (response.result.reviewStatus === 1) {
                this.$router.push('/menu/procurement-orders')
              }
            }
          })
        }
      }
    },
    gotoShopvidi() {
      window.open('https://www.shopvidi.com')
    },
    changeForm(type) {
      this.type = type
    },
    backVisible() {
      this.loginVisible = false
    },
    gotoLogin() {
      if (this.isMobile) {
        this.loginVisible = true
        this.type = 'login'
      } else {
        this.$router.push({path: '/login'})
      }
    },
    gotoRegister() {
      // 登录会隐藏登录注册按钮
      if (this.login) {
        // 如果点击Join us会跳转到review页面进行填写信息
        this.$router.push({path: '/review'})
        return
      }
      // 如果处于未登录状态则进行判断跳转注册
      if (this.isMobile) {
        this.loginVisible = true
        this.type = 'register'
      } else {
        this.$router.push({path: '/register'})
      }
    },
    open(url) {
      if (window.location.origin.indexOf('https://test-shopvidi-admin-ui.hupofintech.com/') > -1) {
        window.open('https://test-thalesmart-manage-ui2.hupofintech.com/brand' + url)
      } else {
        window.open('https://www.shopvidi.com/brand' + url)
      }
    },
    loadBrands() {
      const params = {
        is_deleted: 0
      }
      getAction('/brand/api/v0.2/brands', params).then(response => {
        if (response.success) {
          this.brandList = response.result
        } else {
          this.$message.warning(response.message)
        }
      }).catch(err => {
        this.$message.warning(err)
      }).finally()
    }
  }
}
</script>

<style lang="less" scope>
.bottom{
  height: 47px;
  text-align: center;
  width: 100%;
  font-size: 14px;
  font-family: Avenir;
  font-weight: normal;
  line-height: 30px;
  color: #8F8F8F;
  opacity: 1;
}
.head-border {
  position: fixed;
  background-color: #fff;
  height: 100px;
  left: 0;
  top: 0;
  z-index: 99;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .header{
    margin-left: 50px;
    display: flex;
    align-items: flex-end;
    .logo_img{
      height:45px;
      width:177px;
      cursor: pointer;
    }
    .el-divider.el-divider--vertical{
      height:20px !important
    }
  }
  .header-action{
    display: flex;
    margin-right: 50px;
    .action{
      width:114px;
      height:44px;
      border: 1px solid black;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 10px;
      cursor: pointer;
    }
    .action.black{
      background-color: black;
      color: white;
    }
  }
}
.home_main{
  margin-top: 100px;
  .home_main1{
    height:550px;
    width: 100%;
    background: url('../../assets/img/home/wpp1bg.png') no-repeat;
    background-size:100% 100%;
    .home_main1_content{
      width:96%;
      max-width:1400px;
      margin:0 auto;
      display: flex;
      .home_main1_content_left{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding-top:100px;
        width: 65%;
        .home_main1_content_text{
          height: 180px;
          font-size: 70px;
          font-family: Satoshi-Bold;
          line-height: 92px;
          color: #FFFFFF;
          opacity: 1;
        }
        .home_main1_content_action{
          margin-top: 58px;
          width: 163px;
          height: 50px;
          background-color: #F3E93D;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 14px;
          font-family: Satoshi-Bold;
          line-height: 44px;
          color: #262B2F;
        }
      }
      .home_main1_content_right{
        width: 35%;
        padding-top:44px;
        margin-left: 19px;
        img{
          width: 99%;
          height: 99%;
        }
      }
    }
    .home_main1_content_mobile{
      display: none;
    }
  }
  .home_main_2{
    height: 521px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 90%;
    max-width: 1400px;
    margin: 0 auto;
    .home_main_2_title{
      margin-top: 60px;
      text-align: center;
      width: 900px;
      height: 71px;
      font-size: 56px;
      font-family: Satoshi-Bold;
      line-height: 92px;
      color: #262B2F;
      opacity: 1;
    }
    .home_main_2_sub_title{
      text-align: center;
      margin-top: 20px;
      width: 1192px;
      height: 27px;
      font-size: 18px;
      font-family: Satoshi-Regular;
      font-weight: 500;
      line-height: 92px;
      color: #5D5D5D;
      opacity: 1;
    }
    .brands-swiper{
      padding-top: 160px;
      width: 100%;

      .brands-swiper-list{
        .brands-swiper-img{
          width: 121px;
          height:121px;
          cursor: pointer;
        }
      }
    }
  }
  .home_main_border{
    background-color: #F5F5F5;
    width: 100%;
    height: 1200px;
    .home_main_3{
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 90%;
      max-width: 1400px;
      margin: 0 auto;
      .home_main_3_title{
        margin-top: 60px;
        text-align: center;
        width: 900px;
        height: 71px;
        font-size: 56px;
        font-family: Satoshi-Bold;
        line-height: 92px;
        color: #262B2F;
        opacity: 1;
      }
      .home_main_3_row{
        display: flex;
        width: 100%;
        padding-top:52px;
        .home_main_3_row_sub{
          width: 50%;
          display: flex;
          flex-direction: column;
          align-items: center;
          .home_main_3_row_sub_img{
            height: 280px;
            width: 280px;
            display: flex;
            align-items: center;
            margin-bottom: 20px;
          }
          .home_main_3_row_sub_title{
            padding-top: 15px;
            text-align: center;
            width: auto;
            max-width: 700px;
            height: 45px;
            font-size: 34px;
            font-family: Satoshi-Bold;
            line-height: 20px;
            color: #262B2F;
            opacity: 1;
            border-bottom: 12px solid #F3E93D;
          }
          .home_main_3_row_sub_text{
            text-align: center;
            margin-top: 21px;
            width: auto;
            max-width: 500px;
            height: 94px;
            font-size: 18px;
            font-family: Satoshi-Medium;
            font-weight: 500;
            line-height: 30px;
            color: #5D5D5D;
            opacity: 1;
          }
        }
      }
    }
  }
  .home_main_4{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 90%;
    max-width: 1400px;
    margin: 0 auto;
    height: 460px;
    .home_main_4_title{
      text-align: center;
      margin-top: 58px;
      width: 40%;
      height: 71px;
      font-size: 56px;
      font-family: Satoshi-Bold;
      line-height: 92px;
      color: #262B2F;
      opacity: 1;
    }
    .home_main_4_img{
      margin-top: 43px;
      width: auto;
      max-width: 900px;
    }
    .home_main_4_action{
      margin-top: 43px;
      width: 200px;
      line-height: 50px;
      background: #F3E93D;
      opacity: 1;
      text-align: center;
      font-size: 14px;
      font-family: Satoshi-Bold;
      color: #262B2F;
      cursor: pointer;
    }
  }
}
@media screen and(max-width: 600px) {
  .head-border{
    height: 50px;
    .header{
      margin-left: 10px;
      .logo_img{
        height:23px;
        width:90px;
        cursor: pointer;
      }
      .header-content{
        font-size: 10px;
        font-family: Satoshi;
        font-weight: 500;
        line-height: 20px;
        color: #262B2F;
        opacity: 1;
      }
    }
    .header-action{
      display: flex;
      margin-right: 10px;
      .action{
        width:60px;
        height:30px;
        border: 1px solid black;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .action.black{
        background-color: black;
        color: white;
      }
    }
  }
  .home_main{
    margin-top: 50px;
    .home_main1{
      background: url('../../assets/img/home/wpp1bg_m.png') no-repeat;
      background-size:100% 100%;
      .home_main1_content{
        .home_main1_content_left{
          width: 100%;
          padding-top:113px;
          .home_main1_content_text{
            height: 91px;
            font-size: 30px;
            line-height: 40px;
            color: #FFFFFF;
            opacity: 1;
          }
          .home_main1_content_action{
            margin-top: 13px;
            font-family: Satoshi-Medium;
          }
        }
        .home_main1_content_right{
          display: none;
        }
      }
      .home_main1_content_mobile{
        width: 90%;
        display: flex;
        margin:0 auto;
        margin-top: 69px;
      }
    }
    .home_main_2{
      width: 95%;
      height: 540px;
      .home_main_2_title{
        width: 100%;
        height: 30px;
        font-size: 24px;
        font-family: Satoshi-Bold;
        font-weight: 500;
        line-height: 30px;
        color: #262B2F;
        opacity: 1;
        margin-top: 119px;
      }
      .home_main_2_sub_title{
        width: 100%;
        height: 65px;
        font-size: 14px;
        font-family: Satoshi-Regular;
        font-weight: 400;
        line-height: 20px;
        color: #262B2F;
        opacity: 1;
      }
      .brands-swiper{
        padding-top: 30px;
        .brands-swiper-img{
          width: 89px;
          height:89px;
          cursor: pointer;
        }
      }
    }
    .home_main_border{
      height: 1700px;
      .home_main_3{
        width: 95%;
        max-width:95%;
        .home_main_3_title{
          width: 100%;
          height: 30px;
          font-size: 24px;
          font-family: Satoshi-Bold;
          line-height: 36px;
          color: #262B2F;
          opacity: 1;
        }
        .home_main_3_row{
          flex-direction: column;
          padding-top:32px;
          .home_main_3_row_sub{
            width: 100%;
            .home_main_3_row_sub_img{
              height: 230px;
              width: 230px;
              margin-bottom: 0px;
            }
            .home_main_3_row_sub_title{
              padding-top: 0px;
              height: 35px;
              font-size: 20px;
              font-family: Satoshi-Bold;
              line-height: 45px;
              color: #262B2F;
              opacity: 1;
            }
            .home_main_3_row_sub_text{
              margin-top: 10px;
              height: 94px;
              font-size: 14px;
              font-family: Satoshi;
              font-weight: 400;
              line-height: 25px;
              color: #262B2F;
              opacity: 1;
            }
          }
        }
      }
    }
    .home_main_4{
      height: 200px;
      .home_main_4_title{
        margin-top: 40px;
        width: 100%;
        height: 30px;
        font-size: 24px;
        font-family: Satoshi-Bold;
        line-height: 36px;
        color: #262B2F;
        opacity: 1;
      }
       .home_main_4_action{
         margin-top: 20px;
       }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/home/homepage.vue